export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/parking/index/resources/computed.js